export const ApplicationName = 'Trinity.Portal';

export const QueryParameterNames = {
  ReturnUrl: 'returnUrl',
  Message: 'message'
};

export const ApplicationPaths = {
  DefaultLoginRedirectPath: '/',
  Login: '/Identity/Account/Login',
  LogOut: '/Identity/Account/Logout',
  IdentityRegisterPath: '/Identity/Account/Register',
  IdentityManagePath: '/Identity/Account/Manage'
};
